<template>
  <q-page padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">
        Liberação de Prazo Mínimo dos Meus Liderados
      </p>
    </div>

    <q-table
      flat
      table-header-class="bg-accent text-weight-bold"
      :rows="lideradosFiltrados"
      :columns="columns"
      :loading="carregando"
      row-key="id"
      no-data-label="Nenhum liderado encontrado"
      hide-pagination
      :rows-per-page-options="[0]"
      class="q-mt-md"
    >
      <template v-slot:top-left>
        <q-input
          rounded
          outlined
          dense
          debounce="300"
          v-model="pesquisa"
          placeholder="Pesquisar"
        >
          <template v-slot:prepend>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>

      <template #body-cell-acoes="props">
        <q-td :props="props">
          <q-btn
            style="border-radius: 8px"
            color="primary"
            icon="key"
            label="Liberar Grupos"
            unelevated
            @click="abrirModal(props.row)"
          />
        </q-td>
      </template>
    </q-table>

    <q-dialog v-model="modalAberto" persistent>
      <q-card
        style="
          min-width: 620px;
          max-width: 760px;
          width: 100%;
          height: 700px;
          display: flex;
          flex-direction: column;
          border-radius: 9px;
        "
      >
        <q-card-section class="row items-center q-pb-none">
          <div class="text-h6">
            Selecionar Grupos para Liberação - {{ lideradoSelecionado?.name }}
          </div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>

        <q-card-section class="q-pt-xs">
          <span class="text-body2 text-grey-7">
            Email: {{ lideradoSelecionado?.email }}
          </span>
        </q-card-section>

        <q-card-section class="q-pb-sm q-pt-sm">
          <q-input
            outlined
            dense
            v-model="pesquisaGrupo"
            placeholder="Buscar grupo"
            clearable
          >
            <template v-slot:prepend>
              <q-icon name="search" />
            </template>
          </q-input>
        </q-card-section>

        <q-separator />

        <q-card-section class="q-pt-sm" style="flex: 1; overflow-y: auto">
          <div v-if="carregandoGrupos" class="flex flex-center q-pa-lg">
            <q-spinner color="primary" size="2em" />
          </div>

          <template v-else>
            <div
              v-for="grupo in gruposFiltrados"
              :key="grupo.group_id"
              class="q-mb-sm"
              :class="
                podeSelecionar(grupo) ? 'cursor-pointer' : 'cursor-not-allowed'
              "
              @click="podeSelecionar(grupo) && toggleGrupo(grupo.group_id)"
            >
              <q-card
                flat
                bordered
                style="border-radius: 8px"
                :style="!podeSelecionar(grupo) ? 'opacity: 0.5' : ''"
              >
                <q-card-section horizontal class="items-center q-pa-sm">
                  <q-checkbox
                    :model-value="gruposSelecionados.includes(grupo.group_id)"
                    color="primary"
                    :disable="!podeSelecionar(grupo)"
                    @click.stop="
                      podeSelecionar(grupo) && toggleGrupo(grupo.group_id)
                    "
                  />
                  <q-chip
                    dense
                    color="blue-2"
                    text-color="primary"
                    class="q-ml-xs"
                  >
                    {{ grupo.group_id }}
                  </q-chip>
                  <div class="q-ml-sm">
                    <div class="text-body2 text-weight-medium">
                      {{ grupo.grupo_nome }}
                    </div>
                    <div v-if="grupo.tipo" class="text-caption text-grey-6">
                      {{ grupo.tipo }}
                    </div>
                  </div>
                </q-card-section>
                <q-separator />
                <q-card-section class="q-pa-sm">
                  <div class="row q-col-gutter-sm text-caption">
                    <div class="col-3">
                      <div class="text-grey-6">Última Retirada</div>
                      <div class="text-weight-medium">
                        {{ formatarData(grupo.ultima_retirada) }}
                      </div>
                    </div>
                    <div class="col-3">
                      <div class="text-grey-6">Próxima Retirada</div>
                      <div class="text-weight-medium">
                        {{ formatarData(grupo.prazo_minimo) }}
                      </div>
                    </div>
                    <div class="col-3">
                      <div class="text-grey-6">Qtd. Máx</div>
                      <div class="text-weight-medium">
                        {{ grupo.quantidade_total_regra ?? "-" }}
                      </div>
                    </div>
                    <div class="col-3">
                      <div class="text-grey-6">Já Retirou</div>
                      <div class="text-weight-medium">
                        {{ grupo.quantidade_retirada ?? "-" }}
                      </div>
                    </div>
                  </div>
                </q-card-section>
              </q-card>
            </div>

            <div
              v-if="gruposFiltrados.length === 0"
              class="text-center text-grey-6 q-pa-md"
            >
              Nenhum grupo encontrado
            </div>
          </template>
        </q-card-section>

        <q-separator />

        <q-card-actions class="q-pa-md row items-center">
          <span class="text-caption text-grey-7">
            {{ gruposSelecionados.length }} grupo(s) selecionado(s)
          </span>
          <q-space />
          <q-btn
            style="border-radius: 8px"
            flat
            label="Cancelar"
            v-close-popup
          />
          <q-btn
            style="border-radius: 8px"
            color="primary"
            unelevated
            label="Confirmar Liberação"
            :disable="gruposSelecionados.length === 0 || confirmando"
            :loading="confirmando"
            @click="dialogConfirmacao = true"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog v-model="dialogConfirmacao" persistent>
      <q-card style="min-width: 600px; max-width: 680px; width: 100%">
        <q-card-section>
          <div class="text-h6">Confirmar Liberação</div>
        </q-card-section>

        <q-card-section class="q-py-lg" style="font-size: medium">
          Tem certeza que deseja liberar esse item novamente para o funcionário?
        </q-card-section>

        <q-card-actions align="right" class="q-pa-md">
          <q-btn flat label="Cancelar" v-close-popup />
          <q-btn
            color="primary"
            unelevated
            label="Sim, liberar"
            :loading="confirmando"
            @click="confirmarLiberacao"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

const columns = [
  {
    name: "name",
    label: "Nome",
    field: "name",
    align: "left",
  },
  {
    name: "email",
    label: "Email",
    field: "email",
    align: "left",
  },
  {
    name: "sap",
    label: "ID Usuário",
    field: "sap",
    align: "left",
  },
  {
    name: "acoes",
    label: "Ações",
    field: "acoes",
    align: "center",
  },
];

export default {
  setup() {
    const store = useStore();
    const quasar = useQuasar();

    const carregando = ref(false);
    const liderados = ref([]);
    const pesquisa = ref("");

    const modalAberto = ref(false);
    const lideradoSelecionado = ref(null);
    const grupos = ref([]);
    const gruposSelecionados = ref([]);
    const carregandoGrupos = ref(false);
    const confirmando = ref(false);
    const pesquisaGrupo = ref("");
    const dialogConfirmacao = ref(false);

    const formatarData = (valor) => {
      if (!valor) return "-";
      const [date, time] = valor.split(" ");
      return date.split("-").reverse().join("/") + (time ? " " + time : "");
    };

    const podeSelecionar = (grupo) => {
      if (grupo.dias_para_retirada == null) return false;
      return (
        grupo.dias_para_retirada > 0 &&
        grupo.quantidade_total_regra <= grupo.quantidade_retirada
      );
    };

    const gruposFiltrados = computed(() => {
      if (!pesquisaGrupo.value) return grupos.value;
      const termo = pesquisaGrupo.value.toLowerCase();
      return grupos.value.filter(
        (g) =>
          g.grupo_nome?.toLowerCase().includes(termo) ||
          String(g.group_id ?? "")
            .toLowerCase()
            .includes(termo)
      );
    });

    const lideradosFiltrados = computed(() => {
      if (!pesquisa.value) return liderados.value;
      const termo = pesquisa.value.toLowerCase();
      return liderados.value.filter(
        (l) =>
          l.name?.toLowerCase().includes(termo) ||
          l.email?.toLowerCase().includes(termo) ||
          String(l.sap ?? "")
            .toLowerCase()
            .includes(termo)
      );
    });

    const carregarLiderados = async () => {
      carregando.value = true;
      try {
        const userId = store.state.autenticacao.idBase;
        const response = await store.dispatch("user/getUserEspecifico", {
          id: userId,
        });
        liderados.value = response.data.model?.liderados ?? [];
      } catch {
        quasar.notify({
          message: "Erro ao carregar liderados",
          color: "negative",
          actions: [{ label: "Fechar", color: "white" }],
        });
      } finally {
        carregando.value = false;
      }
    };

    const abrirModal = async (liderado) => {
      lideradoSelecionado.value = liderado;
      gruposSelecionados.value = [];
      grupos.value = [];
      pesquisaGrupo.value = "";
      modalAberto.value = true;
      carregandoGrupos.value = true;
      try {
        const response = await store.dispatch("user/getProdutosGrupos", {
          id: liderado.id,
          page: 1,
          per_page: 1000,
          search: "",
        });
        grupos.value = response.data.result.data ?? [];
      } catch {
        quasar.notify({
          message: "Erro ao carregar grupos",
          color: "negative",
          actions: [{ label: "Fechar", color: "white" }],
        });
      } finally {
        carregandoGrupos.value = false;
      }
    };

    const toggleGrupo = (groupId) => {
      const idx = gruposSelecionados.value.indexOf(groupId);
      if (idx === -1) {
        gruposSelecionados.value.push(groupId);
      } else {
        gruposSelecionados.value.splice(idx, 1);
      }
    };

    const confirmarLiberacao = async () => {
      confirmando.value = true;
      const erros = [];
      for (const groupId of gruposSelecionados.value) {
        try {
          await store.dispatch("user/liberarPrazo", {
            user_id: lideradoSelecionado.value.id,
            group_id: groupId,
          });
        } catch {
          erros.push(groupId);
        }
      }
      confirmando.value = false;
      if (erros.length === 0) {
        quasar.notify({
          message: "Prazo liberado com sucesso",
          color: "positive",
          actions: [{ label: "Fechar", color: "white" }],
        });
        dialogConfirmacao.value = false;
        modalAberto.value = false;
      } else {
        quasar.notify({
          message: `Erro ao liberar ${erros.length} grupo(s)`,
          color: "negative",
          actions: [{ label: "Fechar", color: "white" }],
        });
      }
    };

    onMounted(carregarLiderados);

    return {
      columns,
      carregando,
      liderados,
      pesquisa,
      lideradosFiltrados,
      modalAberto,
      lideradoSelecionado,
      grupos,
      gruposSelecionados,
      carregandoGrupos,
      confirmando,
      pesquisaGrupo,
      gruposFiltrados,
      dialogConfirmacao,
      formatarData,
      podeSelecionar,
      abrirModal,
      toggleGrupo,
      confirmarLiberacao,
    };
  },
};
</script>
